import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { HostInformation } from './system-info.types';
import { DOMAIN_BRAND } from 'src/environments/domain.constants';
/**
 * System information service
 */
@Injectable({
  providedIn: 'root',
})
export class SystemInfoService {
  constructor() {}
  /**
   * @returns HostInformation
   * @memberof SystemInfoService
   */
  private get hostInformation(): HostInformation {
    const host = window.location.hostname;
    let hostInfo: HostInformation;
    switch (host) {
      case 'ppp.cnhinsurance.com':
      case 'dev-espp.epgins.com':
        hostInfo = { country: 'CA', host };
        break;
      default:
        hostInfo = { country: 'US', host };
        break;
    }
    return hostInfo;
  }
  /**
   * @returns Brand name based on the current domain
   * @example 'ESPP', 'CNH', 'BOMAG', etc.
   * @memberof SystemInfoService
   */
  public get brandName(): string {
    const hostname = window.location.hostname;
    return DOMAIN_BRAND[hostname] || '';
  }
  /**
   * @returns boolean
   * @memberof SystemInfoService
   */
  public get isCNH(): boolean {
    const sysInfo = this.hostInformation;
    if (sysInfo) {
      return [sysInfo.host].some((host) =>
        ['ppp.cnhinsurance.com', 'espp-integration-model.epgins.com'].includes(
          host
        )
      );
    }
    return false;
  }
}
